import { types } from "mobx-state-tree"

export const pending = "pending"
export const done = "done"
export const error = "error"
export const notLoaded = "notLoaded"
export default types.enumeration("State", [notLoaded, pending, done, error])



// WEBPACK FOOTER //
// ./src/stores/State.js